import { useTranslations } from 'next-intl';
import Toast from '@/components/ui/Toast/toast';
import { useSocketEvent } from '@/hooks/socket/useSocketEvent';
import { useAppSelector } from '@/redux/hooks';
import { downloadFile } from '@/utils/file.utils';

interface ReportGamePayload {
  correlationId: string;
  downloadUrl: string;
  fileName: string;
  expiresIn: string;
}

interface ReportGameFailedPayload {
  correlationId: string;
  message: string;
}

export function useFairPlayGameReportSocket() {
  const t = useTranslations('fair-play.download-report');
  const userSession = useAppSelector(state => state.user.userSession);
  const isSessionActive = Boolean(userSession);

  useSocketEvent<ReportGamePayload>(
    'gaming.history.report.success',
    async ({ downloadUrl, fileName }) => {
      try {
        await downloadFile(downloadUrl, fileName);
      } catch {
        Toast({
          type: 'error',
          title: t('failed.title'),
          description: t('failed.description'),
        });
      }
    },
    isSessionActive,
  );

  useSocketEvent<ReportGameFailedPayload>(
    'gaming.history.report.failed',
    ({ message }) => {
      Toast({
        type: 'error',
        title: t('failed.title'),
        description: message,
      });
    },
    isSessionActive,
  );
}
